import Image from 'next/image';

import Banner from '../../components/BannerDefault';
import { customLoader } from '../../utils/customLoaderImage';

import style from './servicos.module.scss';

const parse = require('html-react-parser');

export default function Servicos({ dados }) {
  if (!dados) return null;

  const {
    titulo, itens, icone, banner,
  } = dados;

  return (
    <Banner
      image={{ src: banner }}
      width='100%'
      height='fit-content'>
      <div className={style.section}>
        <h2>{parse(titulo)}</h2>
        <ul>
          {itens.map((servico) => (
            <li key={servico.id}>
              <figure>
                <Image
                  alt='Imagem de ap personalizado'
                  src={icone}
                  loader={customLoader}
                  width={30}
                  height={30}
                />
                <figcaption>Imagem de ap personalizado</figcaption>
              </figure>
              <h3>{parse(servico.item)}</h3>
            </li>
          ))}
        </ul>
      </div>
    </Banner>
  );
}
